













import { Component, Vue } from 'vue-property-decorator';

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * Composant de fenêtre modale d'oubli de mot de passe.
 */
@Component
export default class ForgotPasswordDialog extends Vue {
	$refs!: {
		modal: Dialog
	};

	/** Méthodes */
	open() {
		this.$refs.modal.open();
	}
	close() {
		this.$refs.modal.close();
	}
}
